import { httpClient } from '../../../httpClient';

import { IData, IProjectFilter, IProjectList } from '../../../models';
import { ISingleProject } from '../models';

export const getProjects = (filter: IProjectFilter | null, page?: number): Promise<IData<IProjectList>> => {
    return httpClient.get(`projects`, {
        params: {
            category_id: filter ? filter.id : filter,
            page,
        }
    });
};

export const getFilters = (): Promise<IData<IProjectFilter>> => {
    return httpClient.get(`filters`);
};

export const getProject = (name: string): Promise<IData<ISingleProject>> => {
    return httpClient.get(`projects/${name}`);
};
